module.exports = __webpack_public_path__ + "img/348.170c68e6.jpg";